import React, { useContext } from 'react';
import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import useStyles, {
  PreambleTitleTypography,
  PreambleDisclaimerTitleTypography,
} from './styles';
import PlanningButton from '../components/common/PlanningButton';
import { PlanContext } from '../context/PlanContext';

const VenturePlanningToolIntro = ({
  title,
  bodyContent,
  buttonText,
  disclaimer,
  onContinue,
  isMobile = false,
}) => {
  const classes = useStyles();
  const { planningButtonLoading } = useContext(PlanContext);

  return (
    <Stack className={classes.preamblePageContainer}>
      <PreambleTitleTypography className={classes.title} component="h1">
        {title}
      </PreambleTitleTypography>
      <div
        className={classes.bodyContent}
        dangerouslySetInnerHTML={{ __html: bodyContent }}
      />
      <PlanningButton
        text={buttonText}
        onClick={onContinue}
        isLoading={planningButtonLoading}
        disabled={planningButtonLoading}
        width={isMobile ? '250px' : '350px'}
      />
      <Box className={classes.disclaimerContainer}>
        <PreambleDisclaimerTitleTypography
          component="h2"
          className={classes.disclaimerTitle}
        >
          Disclaimers
        </PreambleDisclaimerTitleTypography>
        <Box className={classes.disclaimerContent}>
          <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
        </Box>
      </Box>
    </Stack>
  );
};

VenturePlanningToolIntro.propTypes = {
  title: PropTypes.string.isRequired,
  bodyContent: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default VenturePlanningToolIntro;
